(ns url.resource
  "URL helpers that answer 'what resource does this URL point to?' —
  the registrable domain (`find-true-domain`), the bucket key
  (`url->resource-key`), and whether two URLs identify different
  resources (`url-changed?`).

  All three need the IETF public-suffix list to know where a domain
  ends. The list is loaded once at boot — file IO on the JVM,
  compile-time inline on ClojureScript — and bound here so callers
  don't have to thread it through. A ClojureScript build that never
  works out a URL's site leaves it out of its bundle by setting
  `INCLUDE_PUBLIC_SUFFIX_LIST` false."
  (:require
   [url.core :as url]
   #?@(:clj [[clojure.java.io :as io]
             [clojure.string :as str]]))
  #?(:cljs (:require-macros [url.resource-macros :as macros])))

#?(:cljs (goog-define ^boolean INCLUDE_PUBLIC_SUFFIX_LIST true))

(def public-suffix?
  #?(:clj  (->> (-> "public_suffix_list.dat"
                    io/resource
                    slurp
                    (str/replace #"\s*//.*" "")
                    (str/split #"\R"))
                (remove #{""})
                (into #{}))
     :cljs (if INCLUDE_PUBLIC_SUFFIX_LIST
             (macros/public-suffix-list)
             #{})))

(defn find-true-domain
  [u]
  (url/find-true-domain public-suffix? u))

(defn url->resource-key
  [location]
  (url/url->resource-key public-suffix? location))

(defn url-changed?
  [from-url to-url]
  (url/url-changed? public-suffix? from-url to-url))
